// extracted by mini-css-extract-plugin
module.exports = {"faq":"Collapse_faq__TDXrQ","collapse":"Collapse_collapse__zcEJR","expend":"Collapse_expend__58Ji2","sweep":"Collapse_sweep__1QTyA"};